import React from "react";
import WWOpenDataCom from './wx-name';
export var NameCell = function (_a) {
    var type = _a.type, _b = _a.alias, alias = _b === void 0 ? false : _b, id = _a.id, name = _a.name;
    if (window.isInWeComISV) {
        try {
            var componentType = "" + type + (alias ? 'Alias' : 'Name');
            return React.createElement(WWOpenDataCom, { type: componentType, openid: id });
        }
        catch (_c) {
            return React.createElement(React.Fragment, null, name);
        }
    }
    return React.createElement(React.Fragment, null, name);
};
